// extracted by mini-css-extract-plugin
export default {"imprint":"Footer_imprint__boCil","copyright":"Footer_copyright__gwy+8"};